function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 27.5c6.904 0 12.5-5.596 12.5-12.5S21.904 2.5 15 2.5 2.5 8.096 2.5 15 8.096 27.5 15 27.5z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.188 16.05c-4.375-1.163-8.288-1.025-11.175 0-3.226 1.15-6.263 3.575-9.3 7.9M10.7 3.438c4.64 10.237 5.313 11.062 10.038 22.15L10.7 3.438zm13.213 2.924c-4.65 5.438-11.175 7.075-21.1 7.313L9 13.276l6-1.2 5-2.278 3.913-3.436z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcoDribbble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDI3LjVDMjEuOTAzNiAyNy41IDI3LjUgMjEuOTAzNiAyNy41IDE1QzI3LjUgOC4wOTY0NCAyMS45MDM2IDIuNSAxNSAyLjVDOC4wOTY0NCAyLjUgMi41IDguMDk2NDQgMi41IDE1QzIuNSAyMS45MDM2IDguMDk2NDQgMjcuNSAxNSAyNy41WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNy4xODc1IDE2LjA1QzIyLjgxMjUgMTQuODg3NSAxOC45IDE1LjAyNSAxNi4wMTI1IDE2LjA1QzEyLjc4NzUgMTcuMiA5Ljc1IDE5LjYyNSA2LjcxMjUgMjMuOTVNMTAuNyAzLjQzNzVDMTUuMzM5MiAxMy42NzUgMTYuMDEyNSAxNC41IDIwLjczNzUgMjUuNTg3NUwxMC43IDMuNDM3NVpNMjMuOTEyNSA2LjM2MjVDMTkuMjYyNSAxMS44IDEyLjczNzUgMTMuNDM3NSAyLjgxMjUgMTMuNjc1TDkgMTMuMjc2MkwxNSAxMi4wNzYzTDIwIDkuNzk3N0wyMy45MTI1IDYuMzYyNVoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgIcoDribbble as ReactComponent };